import { render, staticRenderFns } from "./contract-detail.vue?vue&type=template&id=53505eb3&scoped=true&"
import script from "./contract-detail.vue?vue&type=script&lang=js&"
export * from "./contract-detail.vue?vue&type=script&lang=js&"
import style0 from "./contract-detail.vue?vue&type=style&index=0&id=53505eb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53505eb3",
  null
  
)

export default component.exports